import { adminStyles } from "../../../../styles/admin.styles";
import { LoadingState } from "../helpers/admin-certificates-settings-panel.types";
import { twMerge } from "tailwind-merge";

type Props = {
  errorMessage: string | null;
  loadingState: LoadingState;
};

const AdminCertificatesSettingsStatus = ({ errorMessage, loadingState }: Props) => {
  if (errorMessage) {
    return (
      <div
        role="alert"
        data-test="admin-certificates-settings-error"
        className="border border-[#BF0002] bg-[#FFF1F1] px-4 py-3 text-sm text-[#8F0002]"
      >
        {errorMessage}
      </div>
    );
  }

  if (loadingState === "loading") {
    return (
      <div
        data-test="admin-certificates-settings-loading"
        className={twMerge(adminStyles.card.surface, "px-4 py-3 text-sm")}
      >
        Loading certificates settings...
      </div>
    );
  }

  return null;
};

export default AdminCertificatesSettingsStatus;
